import React from 'react'
import { useParams } from 'react-router'
// Component
import Select from './_Select'
import Detail from './_Detail'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { StageContext } from 'components/Stages/__Stages.context'

const Stage: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.StageParams>()

  return (
    <StageContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </StageContext.Provider>
  )
}

export default Stage
